import React, { SFC } from 'react';
import classNames from 'classnames';
import { getTranslator } from '../../../helpers/i18n';
import styles from './footer.module.styl';

const translate = getTranslator('_base._footer');
const currentYear = new Date().getFullYear();

const Footer: SFC = () => (
  <footer className={classNames('mx-footer', styles.footer)}>
    <div className={classNames('row')}>
      <div className={classNames('md-column', 'text-center')}>
        {translate('copyrights', { year: currentYear })}
      </div>
    </div>
  </footer>
);

export default Footer;
